import { PopoverTrigger } from '@radix-ui/react-popover';
import { Pause, Play } from 'lucide-react';

import Edit from '@/shared/assets/edit.png';
import { PageIndicator } from '@/shared/components/page-indicator';
import { Button } from '@/shared/components/ui/button';
import { CardDescription, CardTitle } from '@/shared/components/ui/card';

export const DashboardProjectCardHeaderContent = ({
  kpiName,
  projectName,
  currentPageIndex,
  onCardIndexChange,
  isPaused,
  onTogglePause,
}: {
  kpiName: string | undefined;
  projectName: string;
  currentPageIndex?: number;
  onCardIndexChange?: (index: number) => void;
  isPaused?: boolean;
  onTogglePause?: () => void;
}) => {
  return (
    <>
      <div className="flex flex-1 flex-col">
        <CardTitle>{kpiName}</CardTitle>
        <PopoverTrigger>
          <CardDescription className="flex w-fit cursor-pointer flex-row items-center gap-1.5 text-3xs text-primary-shade-grey-500">
            {projectName} <img src={Edit} alt="Edit" className="size-3" />
          </CardDescription>
        </PopoverTrigger>
      </div>
      <div className="flex items-center gap-2">
        {isPaused !== undefined && onTogglePause !== undefined && (
          <Button
            variant="ghost"
            btnType="icon"
            onClick={onTogglePause}
            className="size-6"
          >
            {isPaused ? (
              <Play className="size-3" />
            ) : (
              <Pause className="size-3" />
            )}
          </Button>
        )}
        {currentPageIndex !== undefined && onCardIndexChange !== undefined && (
          <PageIndicator
            count={4}
            currentPage={currentPageIndex}
            onPageClick={onCardIndexChange}
          />
        )}
      </div>
    </>
  );
};
